import { render, staticRenderFns } from "./select-publish-house.vue?vue&type=template&id=72f17424"
import script from "./select-publish-house.vue?vue&type=script&lang=js"
export * from "./select-publish-house.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports